angular.module('qkr').factory('beneficiariesService', ($http, appConfig, $q, utils, merchantService, immutableUtilityService, gettextCatalog) => ({

		beneficiatyCustomFieldList: [],
	    merchantResponse: null,

		invalidateCache() {
			this.beneficiatyCustomFieldList = [];
			this.viewAbleList = [];
			this.nonViewAbleList = [];
		},

		loadBeneficiaryProfileOptions() {
			const fields = [{
				name: 'Year',
				checked: false
			}, {
				name: 'Class',
				checked: false
			}, {
				name: 'Homegroup',
				checked: false
			}, {
				name: 'Room',
				checked: false
			}, {
				name: 'Grades',
				checked: false
			}, {
				name: 'Custom',
				checked: false
			}];
			return fields;
		},

		getMerchantResponse() {
			return this.merchantResponse;
		},

        createProfileOptions(merchantId) {
			const self = this;
			const profileOptions = self.loadBeneficiaryProfileOptions();
			const deferred = $q.defer();
			const successHandler = (response) => {
				self.merchantResponse = response.id;
				let result = [];
				const reference = {
					name: 'ReferenceNumber',
					checked: true,
					disabled: true
				};
				if (response.enableProfileValidation) {
					result = profileOptions.map(option => {
						if (option.name === 'Year') {
							option.checked = true;
							option.disabled = true;
						}
						return option;
					});
					result = immutableUtilityService.immutableSplice(result, 1, 0, reference);

				} else {
					result = profileOptions;
				}
				deferred.resolve(result);
			};

			const errorHandler = () => {
				deferred.reject(profileOptions);
			};
			// Load merchant information
			if (merchantId) {
				merchantService.loadMerchantResponseForMerchant(merchantId).then(successHandler, errorHandler);
			} else {
				merchantService.loadMerchantResponse().then(successHandler, errorHandler);
			}

			return deferred.promise;
		},

	loadMerchant(id) {
		return merchantService.loadMerchant(id)
	},
	loadDepartmentList() {
		const self = this;
			return $http.get(appConfig.apiUrl + 'outlet/listSupplierDepartments', {
				withCredentials: true
			}).then((response) => {
				self.departmentList = response.data;
				return self.departmentList;
			});
	},

	loadAccessibleSchools(merchantId) {
		return $http.get(appConfig.apiUrl + 'merchant/listManagedByMerchants/' + merchantId, {withCredentials: true})
			.then((response) => response.data);
	},

	updateMerchantManagedBy(merchantId, managedByMerchantId) {
		const command = {
			merchantId: merchantId,
			managedByMerchantId: managedByMerchantId
		}
		return $http.post(appConfig.apiUrl + 'merchant/updateManagedByMerchant', command).then((response) => {
			return response.data;
		});
	},

		loadBeneficiaryCustomFields() {
			const self = this;
			if (utils.hasNoValue(this.beneficiatyCustomFieldList)) {
				return $http.get(appConfig.apiUrl + 'beneficiary/listDefinitions', {
					withCredentials: true
				}).then((response) => {
					self.beneficiatyCustomFieldList = response.data;
					return self.beneficiatyCustomFieldList;
				});
			} else {
				// Instance of deferred is to associate promise as api that can
				// Be used eg: successful or unsuccessful completion, status of
				// The task
				const deferred = $q.defer();
				deferred.resolve(this.beneficiatyCustomFieldList);
				return deferred.promise;
			}
		},
	loadBeneficiaryCustomFieldsForMerchant(merchantId) {
		const self = this;
		 const definitions = $http.get(appConfig.apiUrl + 'beneficiary/listDefinitionsForMerchant/' + merchantId, {withCredentials: true})
			 .then((response) => {
				 response.data;
				 self.beneficiatyCustomFieldList = response.data;
				 return self.beneficiatyCustomFieldList;
			 });
			return definitions;
			},
		updateBeneficiaryOrder(viewAbleList, nonViewAbleList) {
			const sortedFields = [];
			for (var i = 0; i < viewAbleList.length; i++) {
				var newInput = {
					id: viewAbleList[i].id,
					listOrder: viewAbleList[i].listOrder
				};
				sortedFields.push(newInput);
			}
			for (var i = 0; i < nonViewAbleList.length; i++) {
				var newInput = {
					id: nonViewAbleList[i].id,
					listOrder: nonViewAbleList[i].listOrder
				};
				sortedFields.push(newInput);
			}
			const updateCommand = {
				beneficiaryCustomFieldDefinitionList: sortedFields
			};

			return $http.post(appConfig.apiUrl + 'beneficiary/updateOrder', updateCommand);
		},

		updateBeneficiaryDefinition(merchantId, form) {
			let type = 'STRING';
            if (form.definitions && form.definitions.length > 0) {
                type = 'DROPDOWN';
            }
			const beneficiaryDefinitions = {
				merchantId: merchantId,
				id: form.id,
				name: form.fieldLabel,
				originalName: form.originalName,
				type: form.type,
				listOrder: form.listOrder,
				dropdownValues: form.definitions
			};
			return $http.post(appConfig.apiUrl + 'beneficiary/updateDefinition', beneficiaryDefinitions);
		},

		updateBeneficiaryDefinitionValue(beneficiary) {
			return $http.post(appConfig.apiUrl + 'beneficiary/updateDefinitionValue', beneficiary);
		},

		createBeneficiaryDefinition(form) {
			const beneficiaryDefinitions = {
				name: form.fieldLabel,
				type: form.type,
				listOrder: form.listOrder,
				dropdownValues: form.definitions
			};
			return $http.post(appConfig.apiUrl + 'beneficiary/createDefinition', beneficiaryDefinitions);
		},

		/*deleteCustomField(fieldParam) {
			const customFieldDel = {
				id: fieldParam.id
			};
			return $http.post(appConfig.apiUrl + 'beneficiary/deleteDefinition', customFieldDel);
		},*/

		deleteCustomFieldForMerchant(merchantId, fieldParam) {
			const customFieldDel = {
				merchantId: merchantId,
				id: fieldParam.id
			};
			return $http.post(appConfig.apiUrl + 'beneficiary/deleteDefinitionForMerchant', customFieldDel);
		},

		updateAll(viewAbleList, nonViewAbleList, managedSchoolId) {
			const sortedFields = [];
			for (var i = 0; i < viewAbleList.length; i++) {
				var newInput = {
					id: viewAbleList[i].id,
					listOrder: viewAbleList[i].listOrder
				};
				sortedFields.push(newInput);
			}
			for (var i = 0; i < nonViewAbleList.length; i++) {
				var newInput = {
					id: nonViewAbleList[i].id,
					listOrder: nonViewAbleList[i].listOrder
				};
				sortedFields.push(newInput);
			}
			const updateCommand = {
				merchantId: managedSchoolId,
				beneficiaryCustomFieldDefinitionList: sortedFields
			};
			return $http.post(appConfig.apiUrl + 'beneficiary/sendUpdateMessageAll', updateCommand);
		}

	}));



// WEBPACK FOOTER //
// ./src/services/beneficiary.services.js